import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const CustomObjectDetailScene = lazy(() =>
  import("@scenes/CustomObjects").then((module) => ({
    default: module.CustomObjectDetailScene,
  }))
);

export const customObjectDetailNRO: NavigationRoutingObject = {
  Component: CustomObjectDetailScene,
  componentFeatureFlippers: ["accounts_nro_component", "b2b_ea"],
  noKnockoutFallback: true,
  section: "data-settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("accounts-nro-heading", "Accounts"),
  pageNameForTracking: () => "Account Detail",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("accounts-nro-description", "Manage account data, such as prospects and customers"),
  icon: "nav-system-accounts",
  tag: "beta",
  getDeveloperNavigationAllowed: ({ featureOn }) => {
    return featureOn("accounts_nro_component") && featureOn("b2b_ea");
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/dashboard/accounts/:appGroupId",
};
